import './ScrollHere.scss';

const ScrollHere = () => <div id="scroll-here" />;

export default ScrollHere;
